// Company logo URLs (uploaded assets)
export const COMPANY_LOGOS = {
  "JTD of CHS": "https://customer-assets.emergentagent.com/job_task-command-center-25/artifacts/cpload9r_JTD.png",
  "Sweet CHS": "https://customer-assets.emergentagent.com/job_task-command-center-25/artifacts/0sk7wcfv_Sweet%20CHS%20LOGO%20.png",
};

export function logoFor(name) {
  return COMPANY_LOGOS[name] || null;
}
